export default {
  type: 'carousel',
  breakpoints: {
    400: {
      perView: 1,
      gap: 23,
      peek: { before: 25, after: 25 }
    },
    767: {
      perView: 1,
      gap: 23,
      peek: { before: 45, after: 45 }
    },
    1023: {
      perView: 1,
      gap: 0,
      peek: { before: 43, after: 43 }
    },
    9000: {
      perView: 1,
      startAt: 1,
      gap: 0,
      peek: { before: 283, after: 283 }
    }
  }
};
